module.exports = __webpack_public_path__ + "static/media/dash1.42b21c2b.png";